// @ts-nocheck
export const localeCodes =  [
  "en",
  "uk",
  "pl",
  "ru"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_ua_46json_064c24f9",
      load: () => import("#nuxt-i18n/064c24f9" /* webpackChunkName: "locale_ua_46json_064c24f9" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_8c1c25df",
      load: () => import("#nuxt-i18n/8c1c25df" /* webpackChunkName: "locale_pl_46json_8c1c25df" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_f9c37154",
      load: () => import("#nuxt-i18n/f9c37154" /* webpackChunkName: "locale_ru_46json_f9c37154" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    language: undefined
  },
  {
    code: "uk",
    iso: "uk",
    language: undefined
  },
  {
    code: "pl",
    iso: "pl",
    language: undefined
  },
  {
    code: "ru",
    iso: "ru-RU",
    language: undefined
  }
]
/** client **/

/** client-end **/